// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { IAssessmentPlanningGetDetailAttrs } from 'interfaces/back-office/assessment/planning/planning-view.interface'
import { IAssessmentPlanningApiDetailResponse } from 'interfaces/back-office/assessment/planning/planning-api.interface'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'

// Utils
import { withHelper_assessmentScheduleModel } from 'models/extensions/helper'

// Types
const { optional, model, boolean } = types

// Base Model
const AssessmentPlanningStoreModel = model('AssessmentPlanning')
  .props({
    assessmentPlanning_isLoading: optional(boolean, false),
    assessmentPlanning_detail: optional(withHelper_assessmentScheduleModel, {}),
  })
  .actions(self => ({
    assessmentPlanning_SET_LOADING: (payload: boolean): void => {
      self.assessmentPlanning_isLoading = payload
    },
    assessmentPlanning_SET_DETAIL: (payload: IAssessmentPlanningApiDetailResponse['res']['data']): void => {
      self.assessmentPlanning_detail = cast(payload)
    },
    assessmentPlanning_CLEAR_DETAIL: (): void => {
      self.assessmentPlanning_detail = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch assessment planning detail
     *
     * @param {IAssessmentPlanningGetDetailAttrs} payload
     *
     * @return {any} any
     */
    assessmentPlanning_fetchDetail: flow(function* (payload: IAssessmentPlanningGetDetailAttrs) {
      self.assessmentPlanning_SET_LOADING(true)

      const response: IAssessmentPlanningApiDetailResponse =
        yield self.environment.assessmentPlanningApi.assessmentPlanning_getDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
        })

      if (response.ok) {
        self.assessmentPlanning_SET_DETAIL(response.res.data)

        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        if (payload?.onError) payload.onError()
      }

      self.assessmentPlanning_SET_LOADING(false)
    }),
  }))

export const createAssessmentPlanningStoreDefaultModel = () => optional(AssessmentPlanningStoreModel, {})
